/**
 * src/App.jsx
 * Root — เกม Three.js FPS
 */
import { memo } from 'react';
import ThreeGameCanvas from './components/ThreeGameCanvas.jsx';

function App() {
  return (
    <div className="app">
      <ThreeGameCanvas />
    </div>
  );
}

export default memo(App);
